import { Stack } from "@mui/material";
import { Button } from "@/components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { useNavigate } from "react-router-dom";
import { FC } from "react";
import { getDynamicRoute } from "@/utils/url";
import { FooterContainer } from "@/components/commons/FooterContainer";

type TCompanyFooterContainerProps = {
  partnerId?: string;
  hideEdit?: boolean;
};
export const PartnerFooterContainer: FC<TCompanyFooterContainerProps> = ({ partnerId, hideEdit }) => {
  const navigate = useNavigate();
  const editRoute = getDynamicRoute(AppRoutes.rsoEdit, { id: partnerId });
  return (
    <FooterContainer>
      <Stack gap={1} direction="row" justifyContent="space-between" alignItems="center">
        <Button variant="secondary" onClick={() => navigate(AppRoutes.duringContractList)}>
          戻る
        </Button>
        {!hideEdit && (
          <Button type="button" variant="primary" size="sm" onClick={() => navigate(editRoute)}>
            編集
          </Button>
        )}
      </Stack>
    </FooterContainer>
  );
};
